__turbopack_context__.v({
  "close": "index-module-scss-module__ibtoMa__close",
  "content": "index-module-scss-module__ibtoMa__content",
  "dialog-layout": "index-module-scss-module__ibtoMa__dialog-layout",
  "show": "index-module-scss-module__ibtoMa__show",
});
